<template>
<div :class="classModal">
			<div class="modal-background"></div>
  			<div class="modal-card">
	    		<header class="modal-card-head" >
				      <p class="modal-card-title" style="width:90%" >{{title}}</p>	
				      <div style="float:rigth" v-if="close">
				      	<s-button theme="" label="" icon="times-circle" @onclick="closeModal"/>
				      </div>

				</header>
				<section class="modal-card-body">
           <div style="float:left">
             <s-you-tube id="video_import" :club="club"  />
           </div>
           <div style="text-align:right;margin: 5px">
           <s-button label="historique des importations"
                     icon="history"
                    @onclick="openHistorique()"
                    theme="is-primary"
                   
            />
           </div>
            <div class="notification is-info">
              Uploader tous vos membres sous le format EXCEL (.xls, .xlsx, .csv)<br/>
              La première ligne de votre fichier doit contenir les entêtes de colonnes.
            </div>
            <upload-excel-component 
              :on-success="handleSuccess" 
              :before-upload="beforeUpload" 
              v-show="file==null"
              @drop="onDrop"/>
            
              <div v-if="file!=null">
                 Votre fichier <b>{{file.name}}</b> est prêt à être importé.
                 <div style="float:right">
                   <s-button @onclick="file=null" icon="undo" theme="is-warning is-small" label=""/>
                 </div>
              </div>
              <div v-show="file!=null" style="margin-top:20px">
                <div class="notification is-light" >
                  Faites correspondondre les données avec les entêtes de votre fichier.
                </div>
                <div class="headerExcel">
                  <b>Champs des membres</b>
                </div>
                 <div class="headerExcel">
                  <b>Colonnes excel</b>
                </div>
                <div v-for="itemData of arrayData" class="row" >
                  <div class="headerExcel"> {{itemData.label}} =
                    <s-info
                        :open="helpValue==itemData.value"
                        :title="helpValue"
                        :id="helpValue"
                        @close="helpValue=null"
                    >
                      
                       <div v-html="itemData.description">
                       </div>
                    </s-info>
                    
                    <div style="float:right;margin-right:10px;">
                    <s-button icon="info" theme="is-light is-small" label="" @onclick="helpValue=itemData.value"  v-if="itemData.description"/> 
                    </div>
                  </div>
                  <div class="joinColumn">
                      <div class='select is-info is-small'>
                      <select  v-model="joinHeaderJoueur[itemData.value]" class='select'>
                          <option v-if="!itemData.default" value="">Aucune correspondance</option>
                          <option v-if="itemData.default" value="DEFAULT">Valeur par defaut</option>                
                          <option v-for="keyJoin in tableHeader" :value="keyJoin">
                              {{keyJoin}}                    
                          </option>
                      </select>
                    
                      <select v-model="itemData.valueDefault" v-if="joinHeaderJoueur[itemData.value]=='DEFAULT'">
                          <option v-for="valueItemDefault in itemData.values" :value="valueItemDefault=='OUI'">
                              {{valueItemDefault}}
                          </option>
                      </select>
                      </div>
                    
                  </div>
               </div>
              </div>
            <br/>
      <s-modal
        :open="modalHistorique"
        :close="true"
        @close="modalHistorique=false"
        title="Historique des importations"
      >
            Vous ne pouvez pas annuler les mises à jour, mais vous pouvez annuler l'ajout de membres suite à une importation
            <div v-for="historiqueItem in historique" class="historique">
                  <div style="float:right">
                 <s-button 
                        icon="trash" label="Annuler l'importation" theme="is-danger" 
                        @onclick="confirmSupprimerHistorique(historiqueItem.id)"
                        v-if="historiqueItem.add!=0"        
                />
                </div>
                <div>
                Importé le <b> {{formatDate(historiqueItem.date)}} </b>

                </div>
                <div>
                   Membre Ajoutés : {{historiqueItem.add}} 
                </div>
                <div>
                    Membre Mis à jour : {{historiqueItem.update}}
                </div>
               
               
            </div>
      </s-modal>
      <s-confirm
        title="Confirmer l'annuler de cette importation"
        @yes="supprimerHistorique()"
        @no="modalDeleteImportation=false"
        :open="modalDeleteImportation"
      >
          <s-l id="importation_delete">L'annulation de l'importation supprimer tous les membres ajoutés lors de cette importation<br/>Confirmez vous l'annulation ?</s-l>
      </s-confirm>
      <s-modal
        :open="modalErrorNbJoueurs"
        :close="true"
        @close="modalErrorNbJoueurs=false"
      >
        <s-l id="import_error_nbJoueurs">Désolé l'importation n'a pas aboutie<br/>Un club est limité à 300 jours</s-l>
      </s-modal>
      <s-modal
        :open="importationFinshed"
        :title="progress==100 ? 'Importation réussie' : 'Importation en cours'"
        :close="false"
      >
        
        <div>
          Nombre de lignes à importer : {{tableData.length}}<br/>
          {{nbUpdateMembre}} membres mise à jour<br/>
          {{nbAddMembre}} membres ajoutés<br/>
        </div>
        
        <br/>
          <progress-bar
            :options="options"
            :value="progress"
          />
          <br/>
           <s-button icon="" label="Annuler" theme="is-danger" @onclick="annulerImport"
            
          />&nbsp;
          <s-button icon="" label="Confirmer" theme="is-success" @onclick="reinitImport"
            v-if="progress==100"
          />          
      </s-modal>
      
				</section>
        <footer class="modal-card-foot"  >
      			<div style="width:100%;text-align:right">
              <s-button @onclick="save" theme="is-primary is-large" icon="file-import" label="Importer" 
              :disabled="tableHeader.length==0"/>
            </div>
    		</footer>
  </div>

  
</div>
</template>
<style scoped>
      
    .row {
        margin-bottom: 1px;
    }
    .desc {
      font-size: 15px;
    }
    .entete {
      width: 50%;
      font-size: 18px;
      font-weight: bold;
      display: inline-block;
      margin-top: 20px;
      text-align: center;
    }
    .headerExcel {
        width: 50%;
        font-size:18px;
        display: inline-block;
        vertical-align: middle;
        padding-top: 10px;
        
    }
    .joinColumn {
        width: 50%;
        display: inline-block;
    }
    .historique {
        margin: 20px;
        border: thin black solid;
        padding: 5px;
    }
</style>
<script>
import UploadExcelComponent from '@/components/uploadXLS.vue'
import joueur_fct from '@/firebase/joueur'
import club_fct from '@/firebase/club'
import ProgressBar from 'vuejs-progress-bar'
import firebase from "firebase"
import firebase_api from "@/firebase/firebase_api"
export default {
  name: 'UploadExcel',
  props: ["club","title","open","close"],
  components: { UploadExcelComponent },
  computed: {
      progress: {
        get() {
            if (this.tableData.length>0)
              return Math.round(((this.nbAddMembre+this.nbUpdateMembre) / this.tableData.length)*100);
            else
              return 0;
        }
      }
  },
  data() {
    return {
      options: {
        text: {
          color: '#FFFFFF',
          shadowEnable: true,
          shadowColor: '#000000',
          fontSize: 14,
          fontFamily: 'Helvetica',
          dynamicPosition: false,
          hideText: false
        },
        progress: {
          color: '#2dbd2d',
          backgroundColor: '#333333'
        },
        layout: {
          height: 35,
          width: 300,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: 'line'
        }
      },
      file: null,
      modalHistorique: false,
      historique:[],
      modalDeleteImportation: false,
      importationSelected: null,
      nbAddMembre: 0,
      nbUpdateMembre: 0,
      importationFinshed: false,
      classModal: "modal",
      tableData: [],
      dataTest: "",
      reinitTotal: false,
      tableHeader: [],
      joinHeaderJoueur: {},
      helpValue: null,
      joueurData: JSON.parse(JSON.stringify(joueur_fct.object.data)),
      batch: null,
      annulerBatch: false,
      modalErrorNbJoueurs: false,
      arrayData: [
        
        {
          label: "Nom",
          value: "NOM",
          default: false,
          type: "natif"
        },
        {
          label: "Prenom",
          value: "PRENOM",
          default: false,
          type: "natif"
        },
        {
          label: "Adresse",
          value: "ADRESSE",
          default: false,
          type: "natif"
        },
          {
          label: "N° de Licence",
          value: "LICENCE",
          default: false,
          type: "natif"
        },
         
         {
          label: "Email",
          value: "EMAIL",
          default: false,
          type: "natif"
        },
         {
          label: "Tel",
          value: "TELEPHONE",
          default: false,
          type: "natif"
        },
        {
          label: "ID",
          value: "ID",
          default: false,
          type: "auto",
          description: "Il s'agit de l'identifiant du membre. C'est un champ qui est généré automatique. A priori, vous n'avez rien à la saisir"
        },
        {
          label: "Pseudo",
          value: "PSEUDO",
          default: false,
          type: "auto",
          description: "Il s'agit d'un champ automatique NOM + PRENOM"
        }
      ]
    }
  },
  watch: {
			open: function(val) {
				if (val) {
          this.classModal = "modal is-active";
          for (var customId in this.club.customs) {

            var customItem = this.club.customs[customId];
            var arrayItem = {
              label: customItem.label,
              value: customItem.id,
              default: false,
              type: "custom"
            }
            if (this.club.customs[customId].type=="radio") {
               arrayItem.description = "";
              this.club.customs[customId].values.forEach((value, index)=>{
                arrayItem.description += index + " = " + value + "<br/>";
              })
              
            }
            if (this.arrayData.findIndex(elt=>elt.value===customId)==-1)
              this.arrayData.push(arrayItem);
          }
        }
				else
          this.classModal = "modal";
			}
	},
  methods: {
    closeModal() {
      this.$emit("close");
      this.file=null;
    },
    formatDate(date) {
            var options = {weekday: "long", year: "numeric", month: "long", day: "numeric", hour: "2-digit", minute: "2-digit"};
            return (new Date(date)).toLocaleString("fr-Fr",options);
        },
    supprimerHistorique() {
      firebase_api.api.getDb().collection("club").doc(this.club.id)
          .collection("importations")
          .doc(this.importationSelected)
          .delete().then(()=>{
              this.modalDeleteImportation=false;
              this.modalHistorique=false;
          })
    },
    confirmSupprimerHistorique(idImportation) {
        this.importationSelected = idImportation;
        this.modalDeleteImportation=true;
    },
    async openHistorique() {
        this.historique=[];
        var importationRef = await firebase_api.api.getDb().collection("club").doc(this.club.id).collection("importations").orderBy('date').get();
        importationRef.docs.forEach(doc=>{
          this.historique.push(doc.data());
        })
        this.modalHistorique = true;
    },
    onDrop (file) {
      this.file = file;
    },
    annulerImport() {
      this.batch = null;
      this.nbUpdateMembre = 0;
      this.nbAddMembre = 0;
      this.importationFinshed=false;
      this.annulerBatch = true;
    },
    async reinitImport() {
      this.nbUpdateMembre = 0;
      this.nbAddMembre = 0;
      this.importationFinshed=false;
      this.annulerBatch = false;
      await this.batch.commit();
      var clubRef = firebase_api.api.getDb().collection("club").doc(this.club.id)
      var joueurRef = firebase_api.api.getDb().collection("club").doc(this.club.id).collection("joueurs")
      var joueurDoc = await joueurRef.get();
      var nbJoueurs =joueurDoc.docs.length;
      await clubRef.update({
        nbJoueurs: nbJoueurs
      });
      this.file=null;
    },
    async save() {
      var joueurRef = firebase_api.api.getDb().collection("club").doc(this.club.id).collection("joueurs")
      var joueurDoc = await joueurRef.get();
      
      
      
      var arrayPseudo = {};
      this.batch = firebase.firestore().batch();
      this.importationFinshed = true;
      this.annulerBatch = false;
      
      

      var importationRef = firebase_api.api.getDb().collection("club").doc(this.club.id)
        .collection("importations");
      var importationId = importationRef.doc().id;
     

      for (var indexTableData in this.tableData) {
          if (this.annulerBatch) {
            this.annulerImport();
            break;
          }
         else {
          var dataItem = this.tableData[indexTableData];
          var joueurData = JSON.parse(JSON.stringify(joueur_fct.object.data));
          
          for (var key in this.joinHeaderJoueur) {
              switch (key) {
                case "ID":
                  if (dataItem[this.joinHeaderJoueur[key]])
                  joueurData.id = dataItem[this.joinHeaderJoueur[key]];
                  break;
                case "NOM":
                  if (dataItem[this.joinHeaderJoueur[key]])
                  joueurData.nom = dataItem[this.joinHeaderJoueur[key]];
                  break;
                case "PRENOM":
                  if (dataItem[this.joinHeaderJoueur[key]])
                  joueurData.prenom = dataItem[this.joinHeaderJoueur[key]]
                  break;
                case "EMAIL":
                  if (dataItem[this.joinHeaderJoueur[key]])
                  joueurData.email = dataItem[this.joinHeaderJoueur[key]]
                  break;
                case "LICENCE":
                  if (dataItem[this.joinHeaderJoueur[key]])
                  joueurData.licence = dataItem[this.joinHeaderJoueur[key]]
                  break;
                case "TEL":
                  if (dataItem[this.joinHeaderJoueur[key]])
                  joueurData.licence = dataItem[this.joinHeaderJoueur[key]]
                  break;
                case "PSEUDO":
                  if (this.joinHeaderJoueur[key] != "")
                    joueurData.pseudo = dataItem[this.joinHeaderJoueur[key]]
                  break;
                default: 
                  if (typeof(dataItem[this.joinHeaderJoueur[key]])!="undefined") {
                    if (typeof(this.club.customs[key])!="undefined") {
                        joueurData.customs[key] =  dataItem[this.joinHeaderJoueur[key]];
                    }
                  }
                
              }
          }
           var pseudo = "";
           if (typeof(joueurData.pseudo) == 'undefined' || joueurData.pseudo =='') {
              if (joueurData.nom!='') {
              pseudo = joueurData.nom.substr(0,7).toUpperCase();
              if (joueurData.prenom!='')
                  pseudo += "." + joueurData.prenom.substr(0,3).toUpperCase();
              else
                   pseudo += joueurData.nom.substr(8,3).toUpperCase();
              }
              else {
                  if (joueurData.prenom!='')
                    pseudo += joueurData.prenom.substr(0,11).toUpperCase();
                  else
                    pseudo = new Date().getTime().toString().substr(0,11).toUpperCase();
              }
                
              if (typeof(arrayPseudo[pseudo]) == "undefined") 
                  arrayPseudo[pseudo]=0
              else
                  arrayPseudo[pseudo]++;

              if (arrayPseudo[pseudo]==0)
                  joueurData.pseudo = pseudo;
              else
                  joueurData.pseudo = pseudo + arrayPseudo[pseudo];
          }
          
           await club_fct.object.addJoueur(this.club, joueurData, this.batch, importationId, (addJoueur)=>{
             
              if (addJoueur)
                  this.nbAddMembre++;
              else 
                this.nbUpdateMembre++;
             
           })
         }
      }
      this.batch.set(importationRef.doc(importationId), {
          id: importationId,
          add: this.nbAddMembre,
          update: this.nbUpdateMembre,
          date: (new Date()).getTime()
      })
      var nbJoueurs =joueurDoc.docs.length + parseInt(this.nbAddMembre);
      
      if (nbJoueurs>300) {
        this.importationFinshed = false;
        this.modalErrorNbJoueurs = true;
      }

    },
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1
      if (isLt1M) {
        return true
      }
      this.$message({
        message: 'Please do not upload files larger than 1m in size.',
        type: 'warning'
      })
      return false
    },
    handleSuccess({ results, header }) {
      
      this.tableData = results
      this.tableHeader = header
      
      this.arrayData.forEach((dataItem, indexHeader)=>{
        if (this.tableHeader.indexOf(dataItem.value) != -1)
            this.joinHeaderJoueur[dataItem.value] = dataItem.value;
         else {
            if (dataItem.default)
              this.joinHeaderJoueur[dataItem.value] = 'DEFAULT';
            else
              this.joinHeaderJoueur[dataItem.value] = '';
         }
           
      })
    }
  }
}
</script>